export default __webpack_public_path__ + "static/media/imagem_05.3529787c.svg";